export default function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}